import React, { useEffect, useRef, useState } from "react";
import styles from "./ArticlesSection.module.css";


const ARTICLES = [
    {
        source: "Forbes India",
        logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSy6Ayw1VEX8IlCz2m3aKJ4Lh4UHENHFLGfcoUTOnVT57SCbuGanstc1SQz&s=10",
        headline: "From restaurants to scalable brands: Siddhant Dhuwali’s hospitality vision",
        excerpt:
            "India’s hospitality industry has become one of the most dynamic and competitive sectors in the urban lifestyle economy. In this environment, long term success depends not only on strong culinary concepts but also on the ability to build brands that can sustain growth.",
        link: "https://www.forbesindia.com/article/upfront/brand-connect/from-restaurants-to-scalable-brands-siddhant-dhuwalis-hospitality-vision/2992282/1",
    },
    {
        source: "Grazia",
        logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/svgviewer-output%201.png",
        headline: "Siddhant Dhuwali on Food, Hospitality, and The Art of Running a Restaurant",
        excerpt:
            "What really makes a restaurant unforgettable? Restaurateur Siddhant Dhuwali shares his insights into the art and science of creating restaurants that resonate with guests long after the meal is over.",
        link: "https://www.grazia.co.in/lifestyle/siddhant-dhuwali-on-food-hospitality-and-the-art-of-running-a-restaurant-15472.html",
    },
    {
        source: "Elle",
        logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/2025-03-08t065857820z-elle-gourmet-logo.webp",
        headline: "Siddhant Dhuwali: Building the Future of Experiential Hospitality in India",
        excerpt:
            "Founder and investor redefining India’s experiential hospitality through culture-driven restaurants, nightlife, and immersive lifestyle destinations built for scale.",
        link: "https://elle.in/lifestyle/siddhant-dhuwali-building-the-future-of-experiential-hospitality-in-india-11081728",
    },
    {
        source: "ET Now News",
        logo: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/etnow-logo.png",
        headline: "Siddhant Dhuwali on How Social Media is Reshaping the Economics of Modern Dining",
        excerpt:
            "“The brands that will endure are the ones that understand hospitality as a long-term relationship with the guest, not just a moment that looks good on a screen.”",
        link: "https://www.etnownews.com/brand-story/siddhant-dhuwali-on-how-social-media-is-reshaping-the-economics-of-modern-dining-article-153770752",
    },
    {
        source: "Filmfare",
        logo: "", // TODO: upload Filmfare logo
        headline: "Siddhant Dhuwali On Building Restaurants That Blend Hospitality, Lifestyle And Experience",
        excerpt:
            "Entrepreneur Siddhant Dhuwali shares how modern restaurants are evolving into lifestyle destinations built on ambience, emotion, design and guest experiences.",
        link: "https://www.filmfare.com/news/bollywood/siddhant-dhuwali-on-building-restaurants-that-blend-hospitality-lifestyle-and-experience-84155.html",
    },
    {
        source: "Times of India",
        logo: "", // TODO: upload TOI logo
        headline: "Siddhant Dhuwali: The person behind building restaurants that go beyond just food",
        excerpt:
            "Siddhant is the founder behind several restaurant concepts focusing on offering guests not only carefully curated menus but also a welcoming environment to celebrate and connect.",
        link: "https://timesofindia.indiatimes.com/entertainment/siddhant-dhuwali-the-person-behind-building-restaurants-that-go-beyond-just-food/articleshow/129700232.cms",
    },
    {
        source: "Times Now News",
        logo: "", // TODO: upload Times Now logo
        headline: "Siddhant Dhuwali on the Opportunities and Challenges in India’s Fast Growing Restaurant Industry",
        excerpt:
            "For Siddhant Dhuwali, building a strong restaurant portfolio has always been about balancing cuisine with hospitality, prioritizing atmosphere and the overall guest experience.",
        link: "https://www.timesnownews.com/brand-story/siddhant-dhuwali-on-the-opportunities-and-challenges-in-indias-fast-growing-restaurant-industry-article-153907785",
    },
    {
        source: "Zee News",
        logo: "", // TODO: upload Zee News logo
        headline: "Why restaurants are emerging as cultural hubs in cities, Siddhant Dhuwali explains",
        excerpt:
            "Siddhant Dhuwali has transformed Indian dining by designing restaurants as social hubs where atmosphere and community interaction are prioritized alongside food.",
        link: "https://zeenews.india.com/consumer-connect/why-restaurants-are-emerging-as-cultural-hubs-in-cities-siddhant-dhuwali-explains-3032523.html",
    }
];

const ROTATE_INTERVAL = 6000; // ms per article

const ArticlesSection = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const [progressKey, setProgressKey] = useState(0); // restarts progress bar animation

    // Reveal on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.15 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    // Auto-rotate
    useEffect(() => {
        if (isPaused || !visible) return;

        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % ARTICLES.length);
            setProgressKey((k) => k + 1);
        }, ROTATE_INTERVAL);

        return () => clearInterval(interval);
    }, [isPaused, visible]);

    const handleSelect = (index) => {
        setActiveIndex(index);
        setProgressKey((k) => k + 1);
    };

    const active = ARTICLES[activeIndex];

    return (
        <section
            ref={sectionRef}
            className={`${styles.wrapper} ${visible ? styles.show : ""}`}
        //   onMouseEnter={() => setIsPaused(true)}
        //   onMouseLeave={() => setIsPaused(false)}
        >
            <div className={styles.container}>

                {/* ===== HEADER ===== */}
                <header className={styles.header}>
                    <p className={`${styles.eyebrow} ${styles.fade}`}>In The Press</p>
                    <h2 className={`${styles.title} ${styles.fade} ${styles.d1}`}>
                        The Story, As Told By Others
                    </h2>
                </header>

                {/* ===== SPOTLIGHT GRID ===== */}
                <div className={`${styles.grid} ${styles.fade} ${styles.d2}`}>

                    {/* Featured Article */}
                    <div className={styles.featured} key={activeIndex}>
                        {/* <div className={styles.logoRow}>
                            {active.logo ? (
                                <img
                                    src={active.logo}
                                    alt={active.source}
                                    className={styles.logo}
                                />
                            ) : (
                                <span className={styles.sourceName}>{active.source}</span>
                            )}
                        </div> */}

                        <div className={styles.logoRow}>
                            <span className={styles.sourceName}>{active.source}</span>
                        </div>

                        <h3 className={styles.headline}>{active.headline}</h3>

                        <p className={styles.excerpt}>&ldquo;{active.excerpt}&rdquo;</p>

                        <a
                            href={active.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.readLink}
                        >
                            Read Full Article <span className={styles.arrow}>↗</span>
                        </a>

                        {/* Auto-rotate progress bar */}
                        {!isPaused && (
                            <span key={progressKey} className={styles.progress}></span>
                        )}
                    </div>

                    {/* Publication Index */}
                    <div className={styles.index}>
                        {ARTICLES.map((article, i) => (
                            <button
                                key={article.source}
                                className={`${styles.indexItem} ${i === activeIndex ? styles.indexActive : ""
                                    }`}
                                onClick={() => handleSelect(i)}
                            >
                                <span className={styles.indexNumber}>
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className={styles.indexSource}>{article.source}</span>
                            </button>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ArticlesSection;